/**
 * デバイス側スクリプトのテンプレート
 * ZIPファイルに同梱するスクリプト群
 *
 * curl + AWS IoT HTTPS を使用（追加パッケージ不要）
 *
 * テンプレートファイル:
 *   - src/iot-cert-scripts/README.txt.template
 *   - src/iot-cert-scripts/setup.sh.template
 *   - src/iot-cert-scripts/connect-test.sh.template
 *
 * ※ 証明書格納パスはスクリプト実行位置から自動検出
 *    ユーザーによるパス指定は不要
 */

import {
  README_TEMPLATE,
  SETUP_TEMPLATE,
  CONNECT_TEST_TEMPLATE,
  applyTemplate,
} from '../iot-cert-scripts';

/**
 * setup.sh を生成
 * @param {object} config - { thingName, endpoint, region }
 * @returns {string}
 */
export const setupScript = (config) => applyTemplate(SETUP_TEMPLATE, config);

/**
 * connect-test.sh を生成
 * @param {object} config - { thingName, endpoint, region }
 * @returns {string}
 */
export const connectTestScript = (config) => applyTemplate(CONNECT_TEST_TEMPLATE, config);

/**
 * README.txt を生成
 * @param {object} config - { thingName, endpoint, region }
 * @returns {string}
 */
export const readmeText = (config) => applyTemplate(README_TEMPLATE, config);
